/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseListInteger
 */
export interface ResponseListInteger {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListInteger
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListInteger
     */
    message?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ResponseListInteger
     */
    data?: Array<number>;
}

/**
 * Check if a given object implements the ResponseListInteger interface.
 */
export function instanceOfResponseListInteger(value: object): value is ResponseListInteger {
    return true;
}

export function ResponseListIntegerFromJSON(json: any): ResponseListInteger {
    return ResponseListIntegerFromJSONTyped(json, false);
}

export function ResponseListIntegerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListInteger {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function ResponseListIntegerToJSON(json: any): ResponseListInteger {
    return ResponseListIntegerToJSONTyped(json, false);
}

export function ResponseListIntegerToJSONTyped(value?: ResponseListInteger | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'],
    };
}

